module.exports = __webpack_public_path__ + "static/media/29ADMSPC22.740c5a90.jpg";